/* One frame bus owns the dock's scroll/resize work so every controller shares one animation frame. */
  (function(){
    if (window.__wvDockFrameBus) return;

    var callbacks = [];
    var frame = 0;

    function flush(){
      frame = 0;
      callbacks.slice().forEach(function(callback){
        try { callback(); } catch (error) {}
      });
    }

    function schedule(){
      if (!frame && !document.hidden) frame = window.requestAnimationFrame(flush);
    }

    window.__wvDockFrameBus = {
      add: function(callback){
        if (callbacks.indexOf(callback) === -1) callbacks.push(callback);
        schedule();
      },
      schedule: schedule
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) schedule();
    });
  })();

  /* Match dock icon contrast to the page section physically behind the glass. The section's
     own foreground color is the source of truth: image heroes already choose white or dark copy
     for their photography, while ordinary content sections use Willow ink. This avoids pixel
     sampling, canvas work and scroll polling; the shared frame bus performs one point lookup. */
  (function(){
    if (window.__wvDockAdaptiveContrast) return;
    window.__wvDockAdaptiveContrast = true;

    var media = window.matchMedia('(max-width: 767px)');
    var lastSection = null;
    var lastTone = null;

    function luminance(color){
      var values = String(color || '').match(/[\d.]+/g);
      if (!values || values.length < 3) return 0;
      return (
        Number(values[0]) * 0.2126 +
        Number(values[1]) * 0.7152 +
        Number(values[2]) * 0.0722
      );
    }

    function isVisible(element){
      if (!element) return false;
      var rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;
      var style = window.getComputedStyle(element);
      return style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        parseFloat(style.opacity || '1') > 0.02;
    }

    function sectionBehind(dock){
      var rect = dock.getBoundingClientRect();
      var x = Math.round(rect.left + rect.width * 0.5);
      var y = Math.round(rect.top + rect.height * 0.5);
      var stack = document.elementsFromPoint
        ? document.elementsFromPoint(x, y)
        : [document.elementFromPoint(x, y)];

      for (var i = 0; i < stack.length; i++){
        var element = stack[i];
        if (!element || !element.closest) continue;
        if (element.closest('.wv-dock-section, #zsiq_float, #zsiq_chat_wrap')) continue;

        var section = element.closest('.shopify-section');
        if (section) return section;
      }

      return null;
    }

    function sectionWantsLightIcons(section){
      var selectors = [
        '.slideshow-word[aria-current="true"] .premium-home-hero__heading',
        '.slideshow-word[aria-current="true"] .heading',
        '.premium-home-hero__heading',
        '.wv-hero__heading',
        '.banner__content .banner__title',
        '.banner__content .breadcrumb',
        '.banner__content',
        '.section'
      ];

      for (var i = 0; i < selectors.length; i++){
        var candidates = section.querySelectorAll(selectors[i]);
        for (var j = 0; j < candidates.length; j++){
          if (!isVisible(candidates[j])) continue;
          return luminance(window.getComputedStyle(candidates[j]).color) >= 180;
        }
      }

      return luminance(window.getComputedStyle(section).color) >= 180;
    }

    function sync(){
      var dock = document.querySelector('.wv-dock');
      if (!dock) return;

      if (!media.matches){
        dock.classList.remove('wv-dock--inverse');
        lastSection = null;
        lastTone = null;
        return;
      }

      var section = sectionBehind(dock);
      var activeSlide = section && section.querySelector('.slideshow-word[aria-current="true"]');
      var signature = section
        ? section.id + ':' + (activeSlide ? activeSlide.getAttribute('data-index') || 'active' : 'static')
        : 'none';

      if (signature === lastSection) return;
      lastSection = signature;

      var light = Boolean(section && sectionWantsLightIcons(section));
      if (light === lastTone) return;
      lastTone = light;
      dock.classList.toggle('wv-dock--inverse', light);
    }

    window.__wvDockFrameBus.add(sync);
    document.addEventListener('shopify:section:load', function(){
      lastSection = null;
      window.__wvDockFrameBus.schedule();
    });
    document.addEventListener('shopify:block:select', function(){
      lastSection = null;
      window.__wvDockFrameBus.schedule();
    });
  })();

  /* Hide persistent mobile controls only while a software keyboard consumes a substantial part
     of the visual viewport. This also works when the focused field lives inside Zoho's iframe. */
  (function(){
    if (window.__wvKeyboardDockGuard) return;
    window.__wvKeyboardDockGuard = true;

    var root = document.documentElement;
    var visual = window.visualViewport;
    var frame = 0;
    var keyboardOpen = root.classList.contains('wv-keyboard-open');
    var baseline = viewportHeight();
    var orientation = orientationKey();
    var rotationFloor = 0;
    var rotationStartedAt = 0;
    var settleTimerA = 0;
    var settleTimerB = 0;

    function viewportHeight(){
      return Math.round(
        visual && visual.height
          ? visual.height
          : window.innerHeight || 0
      );
    }

    function orientationKey(){
      var angle = null;

      if (
        window.screen &&
        window.screen.orientation &&
        typeof window.screen.orientation.angle === 'number'
      ){
        angle = window.screen.orientation.angle;
      }
      else if (typeof window.orientation === 'number'){
        angle = window.orientation;
      }

      if (angle !== null){
        return Math.abs(angle) % 180 === 90 ? 'landscape' : 'portrait';
      }

      return window.screen && window.screen.width > window.screen.height
        ? 'landscape'
        : 'portrait';
    }

    function focusedElement(){
      var element = document.activeElement;

      while (
        element &&
        element.shadowRoot &&
        element.shadowRoot.activeElement
      ){
        element = element.shadowRoot.activeElement;
      }

      return element;
    }

    function isEditable(element){
      if (!element || element.disabled || element.readOnly) return false;
      if (element.isContentEditable) return true;
      if (element.tagName === 'TEXTAREA') return true;
      if (element.tagName !== 'INPUT') return false;

      return !/^(button|checkbox|color|file|hidden|image|radio|range|reset|submit)$/i
        .test(element.type || 'text');
    }

    function isZohoFrame(element){
      return Boolean(
        element &&
        element.tagName === 'IFRAME' &&
        element.closest &&
        element.closest('#zsiq_chat_wrap, [data-id="zsalesiq"]')
      );
    }

    function focusCanOwnKeyboard(){
      var element = focusedElement();
      return isEditable(element) || isZohoFrame(element);
    }

    function setKeyboardOpen(next){
      keyboardOpen = Boolean(next);
      root.classList.toggle('wv-keyboard-open', keyboardOpen);
    }

    function sync(){
      frame = 0;

      var height = viewportHeight();
      if (!height || document.hidden) return;

      if (!window.matchMedia('(max-width: 767px)').matches){
        baseline = height;
        rotationFloor = 0;
        setKeyboardOpen(false);
        return;
      }

      var focused = focusCanOwnKeyboard();
      var nextOrientation = orientationKey();

      /* Never compare a landscape viewport against a portrait baseline. If rotation happens while
         typing, keep controls hidden until the keyboard-height viewport recovers. */
      if (nextOrientation !== orientation){
        orientation = nextOrientation;

        if (keyboardOpen){
          rotationFloor = height;
          rotationStartedAt = Date.now();
          setKeyboardOpen(true);
          window.setTimeout(schedule, 1050);
        }
        else {
          rotationFloor = 0;
          baseline = height;
          setKeyboardOpen(false);
        }
        return;
      }

      if (rotationFloor){
        rotationFloor = Math.min(rotationFloor, height);

        var recovered = height - rotationFloor >= 120;
        var abandoned = !focused && Date.now() - rotationStartedAt > 900;

        if (!recovered && !abandoned){
          setKeyboardOpen(true);
          return;
        }

        rotationFloor = 0;
        baseline = height;
        setKeyboardOpen(false);
        return;
      }

      /* Pinch zoom also shrinks visualViewport, but is not a keyboard. Safari's browser chrome is
         ignored by the 140px / 20% minimum loss. */
      var zoomed = Boolean(visual && visual.scale > 1.05);
      var lostHeight = baseline - height;
      var keyboardSizedLoss = Math.max(140, baseline * 0.20);
      var shrunken = !zoomed && lostHeight >= keyboardSizedLoss;
      /* A few Safari builds briefly report BODY instead of the focused cross-origin Zoho iframe.
         The open-chat state plus a much larger viewport loss is a safe fallback. */
      var chatFallback = Boolean(
        document.body &&
        document.body.classList.contains('wv-chat-open') &&
        lostHeight >= Math.max(220, baseline * 0.25)
      );

      /* Keep the class latched during the short blur-before-resize sequence on keyboard close. */
      setKeyboardOpen(shrunken && (focused || keyboardOpen || chatFallback));

      if (!keyboardOpen && !focused && !zoomed){
        baseline = Math.max(baseline, height);
      }
    }

    function schedule(){
      if (frame || document.hidden) return;
      frame = window.requestAnimationFrame(sync);
    }

    /* Cross-origin iframe focus timing differs between Safari and Chrome. Short follow-up checks
       catch the final activeElement and viewport state without polling. */
    function scheduleBurst(){
      schedule();
      window.clearTimeout(settleTimerA);
      window.clearTimeout(settleTimerB);
      settleTimerA = window.setTimeout(schedule, 100);
      settleTimerB = window.setTimeout(schedule, 450);
    }

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', scheduleBurst, { passive: true });
    window.addEventListener('focus', scheduleBurst);
    window.addEventListener('blur', scheduleBurst);
    window.addEventListener('pageshow', scheduleBurst);

    if (visual){
      visual.addEventListener('resize', schedule, { passive: true });
      visual.addEventListener('scroll', schedule, { passive: true });
    }

    document.addEventListener('focusin', scheduleBurst, true);
    document.addEventListener('focusout', scheduleBurst, true);
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) scheduleBurst();
    });

    scheduleBurst();
  })();

  /* One passive, frame-throttled controller for the mobile back-to-top button. */
  (function(){
    if (window.__wvBackToTopBound) return;
    window.__wvBackToTopBound = true;

    var selector = '.wv-back-to-top';

    function getButton(){
      return document.querySelector(selector);
    }

    function sync(){
      var button = getButton();
      if (!button) {
        document.documentElement.classList.remove('wv-back-to-top-visible');
        return;
      }

      var isVisible = window.scrollY > Math.max(900, window.innerHeight * 1.25);
      button.hidden = false;
      button.toggleAttribute('data-visible', isVisible);
      document.documentElement.classList.toggle('wv-back-to-top-visible', isVisible);
    }

    document.addEventListener('click', function(event){
      var button = event.target.closest && event.target.closest(selector);
      if (!button) return;
      event.preventDefault();
      var reduced = window.theme && window.theme.config
        ? window.theme.config.motionReduced
        : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    window.__wvDockFrameBus.add(sync);
    document.addEventListener('shopify:section:load', window.__wvDockFrameBus.schedule);
  })();

  /* Keep Filter and sort fully above the rendered dock. Liquid can only estimate the dock height,
     while iOS Safari changes its visual viewport as browser chrome expands/collapses. Measure the
     real fixed capsule instead, then share one bottom offset with the interactive button and its
     separate non-interactive glass plate. */
  (function(){
    if (window.__wvFilterDockPosition) return;
    window.__wvFilterDockPosition = true;

    var frame = 0;
    var lastBottom = -1;
    var dockObserver = null;

    function sync(){
      frame = 0;
      if (!window.matchMedia('(max-width: 767px)').matches) return;

      var dock = document.querySelector('.wv-dock');
      if (!dock) return;

      var rect = dock.getBoundingClientRect();
      if (!rect.height) return;

      /* Use the dock's own fixed-position coordinate system. On iOS Safari, window.innerHeight
         can lag behind the dynamic visual viewport and place this pill inside the dock. */
      var dockBottom = parseFloat(window.getComputedStyle(dock).bottom);
      if (!Number.isFinite(dockBottom)) return;
      var bottom = Math.max(0, Math.round(dockBottom + rect.height + 12));
      if (bottom === lastBottom) return;

      lastBottom = bottom;
      document.documentElement.style.setProperty('--wv-filter-bottom', bottom + 'px');

      var sticky = document.querySelector('facet-sticky');
      if (sticky && typeof sticky.scheduleObserverRefresh === 'function'){
        sticky.scheduleObserverRefresh();
      }
    }

    function schedule(){
      if (frame || document.hidden) return;
      frame = requestAnimationFrame(sync);
    }

    function observeDock(){
      var dock = document.querySelector('.wv-dock');
      if (!dock) return;
      if (dockObserver) dockObserver.disconnect();
      if ('ResizeObserver' in window){
        dockObserver = new ResizeObserver(schedule);
        dockObserver.observe(dock);
      }
      schedule();
    }

    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport){
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) schedule();
    });
    document.addEventListener('shopify:section:load', observeDock);

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', observeDock, { once: true });
    } else {
      observeDock();
    }
  })();

  /* Hide the mobile dock when the real footer enters the usable viewport above it.
     IntersectionObserver keeps this scroll-driven state out of the synchronous layout path. */
  (function(){
    if (window.__wvDockFooterMode) return;
    window.__wvDockFooterMode = true;

    var footerObserver = null;
    var dockSizeObserver = null;
    var connectFrame = 0;
    var lastDockHeight = 0;
    var media = window.matchMedia('(max-width: 767px)');

    function setVisible(visible){
      document.body.classList.toggle('wv-footer-visible', Boolean(visible));
    }

    function disconnect(){
      if (footerObserver) footerObserver.disconnect();
      if (dockSizeObserver) dockSizeObserver.disconnect();
      footerObserver = null;
      dockSizeObserver = null;
    }

    function connect(){
      connectFrame = 0;
      disconnect();

      if (!media.matches){
        setVisible(false);
        return;
      }

      var dock = document.querySelector('.wv-dock');
      var footer = document.querySelector('.footer-group .footer');
      if (!dock || !footer){
        setVisible(false);
        return;
      }

      var dockRect = dock.getBoundingClientRect();
      lastDockHeight = Math.round(dockRect.height);
      var bottomInset = Math.max(0, Math.ceil(window.innerHeight - dockRect.top + 12));

      footerObserver = new IntersectionObserver(function(entries){
        var visible = entries.some(function(entry){
          return entry.isIntersecting && entry.boundingClientRect.bottom > 0;
        });
        setVisible(visible);
      }, {
        root: null,
        rootMargin: '0px 0px -' + bottomInset + 'px 0px',
        threshold: 0
      });
      footerObserver.observe(footer);

      if ('ResizeObserver' in window){
        dockSizeObserver = new ResizeObserver(function(entries){
          var entry = entries[0];
          if (!entry) return;

          var box = entry.borderBoxSize;
          var blockSize = box && (box[0] || box).blockSize;
          var nextHeight = Math.round(blockSize || entry.target.getBoundingClientRect().height);
          if (!nextHeight || nextHeight === lastDockHeight) return;

          lastDockHeight = nextHeight;
          scheduleConnect();
        });
        dockSizeObserver.observe(dock);
      }
    }

    function scheduleConnect(){
      if (connectFrame || document.hidden) return;
      connectFrame = window.requestAnimationFrame(connect);
    }

    window.addEventListener('resize', scheduleConnect, { passive: true });
    if (window.visualViewport){
      window.visualViewport.addEventListener('resize', scheduleConnect, { passive: true });
    }
    if (media.addEventListener){
      media.addEventListener('change', scheduleConnect);
    } else if (media.addListener){
      media.addListener(scheduleConnect);
    }
    document.addEventListener('shopify:section:load', scheduleConnect);
    document.addEventListener('visibilitychange', function(){
      if (!document.hidden) scheduleConnect();
    });

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', scheduleConnect, { once: true });
    } else {
      scheduleConnect();
    }
  })();

  /* ---- TAP INSPECTOR (opt-in) -----------------------------------------------------------------
     Add ?wvdebug=1 to any URL to show, at the top of the screen, which element actually receives each
     touch and its parent chain. Off for everyone else, so customers never see it. It exists because
     the storefront is unreachable from the environment this theme is edited in, so hit-testing cannot
     be checked remotely — this reports the same thing document.elementFromPoint would. ---- */
  (function(){
    if (location.search.indexOf('wvdebug=1') === -1) return;
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;left:8px;right:8px;top:8px;z-index:99999;background:rgba(0,0,0,.88);' +
      'color:#fff;font:12px/1.4 -apple-system,system-ui,sans-serif;padding:9px 11px;border-radius:10px;' +
      'pointer-events:none;white-space:pre-wrap;word-break:break-word';
    box.textContent = 'wv-debug — коснись любого места';
    function name(el){
      if (!el) return 'ничего';
      var s = el.tagName.toLowerCase();
      if (el.id) s += '#' + el.id;
      var c = (typeof el.className === 'string') ? el.className.trim() : '';
      if (c) s += '.' + c.split(/\s+/).slice(0, 3).join('.');
      return s;
    }
    function chain(el){
      var out = [], n = 0;
      while (el && n < 4){ out.push(name(el)); el = el.parentElement; n++; }
      return out.join('\n   ↑ ');
    }
    function report(x, y){
      box.textContent = 'касание ' + Math.round(x) + ',' + Math.round(y) + '\n' + chain(document.elementFromPoint(x, y));
    }
    function onStart(e){
      var t = e.touches ? e.touches[0] : e;
      if (t) report(t.clientX, t.clientY);
    }
    /* Registered BEFORE the dock's own opener below, so it still reports even though that one calls
       stopImmediatePropagation. Says which branch the opener will take for this tap. */
    function onClick(e){
      var t = e.target.closest && e.target.closest('.wv-dock [data-wv-open]');
      if (!t){
        var any = e.target.closest && e.target.closest('.wv-dock__item');
        box.textContent = 'click: ' + (any ? 'пункт дока без data-wv-open (обычная ссылка) → ' + name(any)
                                            : 'вне дока → ' + name(e.target));
        return;
      }
      var id = t.getAttribute('data-wv-open');
      var el = document.getElementById(id);
      box.textContent = 'click: ' + name(t) +
        '\ndrawer id: ' + id +
        '\nнайден в DOM: ' + (el ? 'да' : 'НЕТ') +
        (el ? '\ntypeof show: ' + (typeof el.show) +
              '\ntypeof hide: ' + (typeof el.hide) +
              '\nel.open: ' + JSON.stringify(el.open) +
              '\nветка: ' + (typeof el.show !== 'function' ? 'ВЫХОД — тап потерян'
                            : (el.open ? 'hide() — закрываем уже закрытое' : 'show() — открываем'))
            : '');
    }
    function attach(){
      document.body.appendChild(box);
      document.addEventListener('touchstart', onStart, true);
      document.addEventListener('pointerdown', onStart, true);
      document.addEventListener('click', onClick, true);
    }
    if (document.body){ attach(); } else { document.addEventListener('DOMContentLoaded', attach); }
  })();

  /* Apple-style press feedback: add .wv-pressed on pointer/touch DOWN (instant squish), remove on
     up/cancel/leave (springs back). CSS :active also covers it, but iOS :active is unreliable on
     non-link elements — this guarantees the "it reacted to my tap" feel. */
  (function(){
    if (window.__wvDockPress) return; window.__wvDockPress = true;
    function down(e){
      var it = e.target.closest && e.target.closest('.wv-dock__item');
      if (it){
        it.classList.add('wv-pressed');
        it.setAttribute('data-focus-origin', 'pointer');
      }
    }
    function clearAll(){ var els = document.querySelectorAll('.wv-pressed'); for (var i=0;i<els.length;i++){ els[i].classList.remove('wv-pressed'); } }
    function restoreKeyboardFocus(e){
      var it = e.target.closest && e.target.closest('.wv-dock__item');
      if (it){ it.removeAttribute('data-focus-origin'); }
    }
    function clearFocusOrigin(e){
      var it = e.target.closest && e.target.closest('.wv-dock__item');
      if (it){ it.removeAttribute('data-focus-origin'); }
    }
    document.addEventListener('pointerdown', down, true);
    document.addEventListener('pointerup', clearAll, true);
    document.addEventListener('pointercancel', clearAll, true);
    document.addEventListener('keydown', restoreKeyboardFocus, true);
    document.addEventListener('focusout', clearFocusOrigin, true);
    window.addEventListener('blur', clearAll);
    /* Fallback for engines without Pointer Events. */
    document.addEventListener('touchstart', down, true);
    document.addEventListener('touchend', clearAll, true);
  })();

  /* Open the theme's native drawers from our dock on the FIRST physical tap.
     iOS can occasionally drop the synthesized click when a fixed control sits above backdrop-filter.
     Pointer-up is earlier and reliable; the following click is swallowed so the drawer cannot
     double-toggle. Keyboard activation still uses the click path. */
  (function(){
    if (window.__wvDockBound) return; window.__wvDockBound = true;

    var pending = Object.create(null);
    var tagById = {
      MenuDrawer: 'menu-drawer',
      SearchDrawer: 'search-drawer',
      CartDrawer: 'cart-drawer'
    };
    var press = null;
    var suppressTrigger = null;
    var suppressClickUntil = 0;

    function triggerFrom(event){
      return event.target.closest && event.target.closest('.wv-dock [data-wv-open]');
    }

    function activate(trigger){
      var id = trigger.getAttribute('data-wv-open');
      var el = document.getElementById(id);
      if (!el) return false;

      if (typeof el.show !== 'function' && window.customElements){
        try{ customElements.upgrade(el); }catch(_){}
      }
      if (typeof el.show !== 'function') return false;

      if (el.open && typeof el.hide === 'function'){
        el.hide();
        return true;
      }

      el.show(trigger);

      // Cart drawer: always open its first tab, not an empty Recently-viewed panel.
      var tl = el.querySelector && el.querySelector('[is="tab-list"]');
      if (tl){
        var firstTab = tl.querySelector('[aria-controls]');
        if (firstTab){ try{ firstTab.click(); }catch(_){} }
      }
      return true;
    }

    function activateOrQueue(trigger){
      if (activate(trigger)) return;

      var id = trigger.getAttribute('data-wv-open');
      if (pending[id]) return;

      var el = document.getElementById(id);
      var tag = (el && el.localName) || tagById[id];
      if (!tag || !window.customElements || typeof customElements.whenDefined !== 'function'){
        if (trigger.href) window.location.href = trigger.href;
        return;
      }

      pending[id] = true;
      customElements.whenDefined(tag).then(function(){
        delete pending[id];
        if (!activate(trigger) && trigger.href) window.location.href = trigger.href;
      }).catch(function(){
        delete pending[id];
        if (trigger.href) window.location.href = trigger.href;
      });
    }

    function claim(event, trigger){
      event.preventDefault();
      event.stopImmediatePropagation();
      activateOrQueue(trigger);
    }

    if (window.PointerEvent){
      document.addEventListener('pointerdown', function(event){
        var trigger = triggerFrom(event);
        if (!trigger || event.isPrimary === false) return;
        press = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          trigger: trigger
        };
      }, true);

      document.addEventListener('pointercancel', function(){ press = null; }, true);

      document.addEventListener('pointerup', function(event){
        if (!press || press.id !== event.pointerId) return;
        var trigger = triggerFrom(event);
        var moved = Math.abs(event.clientX - press.x) > 14 || Math.abs(event.clientY - press.y) > 14;
        var same = trigger && trigger === press.trigger;
        var original = press.trigger;
        press = null;

        /* Suppress the synthetic click after either a completed tap or a drag that began on the dock.
           The tap was already handled here; a drag must not accidentally open a drawer. */
        suppressTrigger = original;
        suppressClickUntil = Date.now() + 900;
        if (!same || moved) return;

        claim(event, original);
      }, true);
    }
    else {
      /* Old WebKit fallback. Modern iPhones take the Pointer Events path above. */
      document.addEventListener('touchend', function(event){
        var trigger = triggerFrom(event);
        if (!trigger) return;
        suppressTrigger = trigger;
        suppressClickUntil = Date.now() + 900;
        claim(event, trigger);
      }, { capture: true, passive: false });
    }

    document.addEventListener('click', function(event){
      var trigger = triggerFrom(event);
      if (!trigger) return;

      if (trigger === suppressTrigger && Date.now() < suppressClickUntil){
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressTrigger = null;
        suppressClickUntil = 0;
        return;
      }

      /* Keyboard activation and browsers that do not emit a preceding pointer event. */
      claim(event, trigger);
    }, true);
  })();

  /* Round the dock's top back when the Add-to-cart bar is hidden, and flatten it when
     the bar is visible so both controls read as one block. The theme already exposes sticky-form
     visibility through style changes; observers mirror that state without measuring on scroll. */
  (function(){
    if (window.__wvDockSolo) return;
    window.__wvDockSolo = true;

    function start(){
      var dock = document.querySelector('.wv-dock');
      if (!dock) return false;

      if (!/(^|\s)template-(product|collection)(\s|$)/.test(document.body.className)){
        dock.classList.add('wv-dock--solo');
        return true;
      }

      var isCollection = /(^|\s)template-collection(\s|$)/.test(document.body.className);
      if (isCollection){
        dock.classList.add('wv-dock--solo');
        dock.style.removeProperty('bottom');
        document.body.classList.remove('wv-glass-joined');
        return true;
      }

      function getBar(){
        return document.querySelector('.product-sticky-form__card');
      }

      function barVisible(card){
        var styles = window.getComputedStyle(card);
        return styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          parseFloat(styles.opacity || '1') > 0.5;
      }

      var glassOn = null;
      var barHeight = 0;
      var syncFrame = 0;

      function setGlass(on){
        on = Boolean(on);
        if (glassOn === on) return;
        glassOn = on;
        document.body.classList.toggle('wv-glass-joined', on);
      }

      function measureBar(card){
        var height = Math.round(card.getBoundingClientRect().height);
        if (height && height !== barHeight){
          barHeight = height;
          document.documentElement.style.setProperty('--wv-buybar-h', height + 'px');
        }
      }

      function sync(){
        syncFrame = 0;
        var card = getBar();

        if (!card){
          dock.classList.add('wv-dock--solo');
          dock.style.removeProperty('bottom');
          setGlass(false);
          return;
        }

        var visible = barVisible(card);
        dock.classList.toggle('wv-dock--solo', !visible);
        dock.style.removeProperty('bottom');

        if (!visible){
          setGlass(false);
          return;
        }

        measureBar(card);
        setGlass(true);
      }

      function scheduleSync(){
        if (syncFrame || document.hidden) return;
        syncFrame = window.requestAnimationFrame(sync);
      }

      document.addEventListener('variant:change', scheduleSync);

      var observedCard = null;
      var cardObserver = new MutationObserver(scheduleSync);
      var sizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleSync) : null;

      function observeCard(){
        var card = getBar();
        if (card === observedCard) return;

        cardObserver.disconnect();
        if (sizeObserver) sizeObserver.disconnect();
        observedCard = card;

        if (card){
          cardObserver.observe(card, {
            attributes: true,
            attributeFilter: ['style', 'class', 'hidden']
          });
          if (sizeObserver) sizeObserver.observe(card);
        }
        scheduleSync();
      }

      observeCard();

      var stickyHost = document.querySelector('product-sticky-form') ||
        document.querySelector('.main-product');
      if (stickyHost){
        new MutationObserver(observeCard).observe(stickyHost, {
          childList: true,
          subtree: true
        });
      }

      document.addEventListener('visibilitychange', function(){
        if (!document.hidden) scheduleSync();
      });
      scheduleSync();
      return true;
    }

    if (!start()){
      var attempts = 0;
      var interval = window.setInterval(function(){
        attempts++;
        if (start() || attempts > 40) window.clearInterval(interval);
      }, 150);
    }
  })();

  /* Clear classes left by a Theme Editor hot reload of the previous tuck implementation. */
  document.body.classList.remove('wv-dock-tuck', 'wv-dock-noanim');
